import { render, staticRenderFns } from "./SubmitPassword.vue?vue&type=template&id=2b5c6e4a&"
import script from "./SubmitPassword.vue?vue&type=script&lang=js&"
export * from "./SubmitPassword.vue?vue&type=script&lang=js&"
import style0 from "./SubmitPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports